module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.elements), function(tab) {
    return (tab.children) ? _c('div', {
      key: tab.name,
      staticClass: "lead-update--tab",
      class: {
        'is-hidden': _vm.activeTab != tab.name
      }
    }, [_c('div', {
      staticClass: "row gutter-lg"
    }, [_c('div', {
      staticClass: "col-md-5 col-lg-5 offset-md-1"
    }, [_c('lead-update-monitor', {
      staticClass: "inside-content",
      class: {
        'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
      },
      attrs: {
        "structure": _vm.structure,
        "progress": _vm.progress,
        "errors": _vm.errors,
        "users": _vm.users,
        "item": _vm.item,
        "leadReviewEnabled": _vm.leadReviewEnabled
      },
      on: {
        "openBusinessCard": _vm.triggerPopup,
        "input": _vm.nestedUpdate
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-5 col-ls-5 lead-mask"
    }, [_c('lead-mask', {
      attrs: {
        "language": _vm.language,
        "elements": tab.children,
        "item": _vm.item,
        "errors": _vm.errors
      },
      on: {
        "change": _vm.change,
        "populate-fields": _vm.populateFields
      }
    })], 1)])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "lead-update--tab lead-update--tab-kits",
    class: {
      'is-hidden': _vm.activeTab != 'kits_tab'
    }
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5 offset-md-1"
  }, [_c('lead-update-monitor', {
    staticClass: "inside-content",
    class: {
      'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
    },
    attrs: {
      "structure": _vm.structure,
      "progress": _vm.progress,
      "errors": _vm.errors,
      "users": _vm.users,
      "item": _vm.item,
      "leadReviewEnabled": _vm.leadReviewEnabled
    },
    on: {
      "openBusinessCard": _vm.triggerPopup,
      "input": _vm.nestedUpdate
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
  }, [_c('lead-update-business-kit', {
    attrs: {
      "project_id": _vm.id,
      "errors": _vm.errors,
      "item": _vm.item,
      "business_kit_id": _vm.businesskit_id,
      "id": _vm.lead_id
    },
    on: {
      "send_businesskit": _vm.sendBusinesskit,
      "input": _vm.nestedUpdate,
      "bkIdChange": _vm.setBusinessKitId
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "lead-update--tab lead-update--tab-kits",
    class: {
      'is-hidden': _vm.activeTab != 'stats_tab'
    }
  }, [_c('div', {
    staticClass: "row gutter-lg"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-5 offset-md-1"
  }, [_c('lead-update-monitor', {
    staticClass: "inside-content",
    class: {
      'hide': !_vm.showUpdateMonitor, 'show': _vm.showUpdateMonitor
    },
    attrs: {
      "structure": _vm.structure,
      "progress": _vm.progress,
      "errors": _vm.errors,
      "users": _vm.users,
      "item": _vm.item,
      "leadReviewEnabled": _vm.leadReviewEnabled
    },
    on: {
      "openBusinessCard": _vm.triggerPopup,
      "input": _vm.nestedUpdate
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.savedAt))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5"
  }, [_c('lead-update-statistics', {
    attrs: {
      "lead-id": _vm.lead_id,
      "project-id": _vm.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "visibility-icon"
  }, [_c('q-checkbox', {
    attrs: {
      "checked-icon": "visibility_off",
      "unchecked-icon": "visibility_on"
    },
    model: {
      value: (_vm.showUpdateMonitor),
      callback: function($$v) {
        _vm.showUpdateMonitor = $$v
      },
      expression: "showUpdateMonitor"
    }
  })], 1), _vm._v(" "), _c('page-saver', {
    attrs: {
      "sticky": true,
      "isModified": !this.isSaved(),
      "changeCount": _vm.saveDiff()
    },
    on: {
      "save": _vm.submit,
      "cancel": _vm.cancel
    }
  }), _vm._v(" "), _c('business-card-popup', {
    attrs: {
      "item": _vm.item,
      "open": _vm.popup_business_card_open
    }
  }), _vm._v(" "), _c('lead-create', {
    attrs: {
      "id": _vm.id
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ddc24a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdate.vue
// module id = 1877
// module chunks = 0